export const TEXT_STRING = "Неверный ввод";
export const TEXT_REQUIRED = "Обязательно";
